import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { FormSettingsDataModel } from './ltdi.manual.form/types';



export const useFlowSettingsChecks = (settings: FormSettingsDataModel) => {

    const isDigitalOccupation = (text: string) => {
        if (!text) return false;
        return settings.digital?.occ?.list?.find(word => text.toLowerCase().indexOf(word.toLowerCase()) !== -1);
    };

    const isIneligibleOccupation = (text: string) => {
        if (!text) return false;
        return settings.ineligible?.occ?.list?.find(word => text.toLowerCase().indexOf(word.toLowerCase()) !== -1);
    };

    const isIneligibleHealthIssue = (text: string) => {
        if (!text) return false;
        return settings.ineligible?.healthIssues?.list?.find(word => text.toLowerCase().indexOf(word.toLowerCase()) !== -1);
    };

    const isWhiltelistedOcc = (text: string) => {
        if (!text) return false;
        return settings.whitelist?.occ?.list?.find(word => text.toLowerCase().indexOf(word.toLowerCase()) !== -1);
    };

    const isHoursWorkedWhiltelistedOcc = (text: string) => {
        if (!text) return false;
        return settings.whitelist?.hoursWorkedLimitOccs?.list?.find(word => text.toLowerCase().indexOf(word.toLowerCase()) !== -1);
    };

    const isMinRatingOcc = (text: string) => {
        if (!text) return false;
        return settings.whitelist?.ratingOcc?.list?.find(word => text.toLowerCase().indexOf(word.toLowerCase()) !== -1);
    };

    return {
        isDigitalOccupation,
        isIneligibleHealthIssue,
        isIneligibleOccupation,
        isWhiltelistedOcc,
        isHoursWorkedWhiltelistedOcc,
        isMinRatingOcc
    };
};